import { IntegrationsMapping } from "../../integrations/IntegrationsMapping";

// aligned with backend/postgres/constants.py
export const RAW_DATA_DELIMITER = ">";

const toTitleCase = (str) =>
  str.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

export const isRawDataField = (fieldName) =>
  typeof fieldName === "string" && fieldName.includes(RAW_DATA_DELIMITER);

export const parseRawDataField = (fieldName) => {
  const [integration, field] = fieldName.split(RAW_DATA_DELIMITER, 2);
  return { integration, field };
};

const getIntegrationDisplayName = (integrationCode) => {
  const mapping = IntegrationsMapping[integrationCode];
  return mapping?.shortDisplayName || mapping?.displayName || integrationCode;
};

export const formatFieldHeaderName = (fieldName) => {
  if (isRawDataField(fieldName)) {
    const { integration, field } = parseRawDataField(fieldName);
    return `${toTitleCase(field)} (${getIntegrationDisplayName(integration)})`;
  } else {
    return toTitleCase(fieldName);
  }
};

export const entityHasAnyRawData = (entity) =>
  Object.keys(entity).some((key) => isRawDataField(key));

export const addRawDataToEntities = (
  entities,
  rawDataByCustomerIdAndEntityId
) => {
  for (const entity of entities) {
    for (const [key, value] of Object.entries(
      rawDataByCustomerIdAndEntityId?.[entity.customer_id]?.[
        entity.entity_id
      ] ?? {}
    )) {
      entity[key] = value;
    }
  }
};
